import styled from "@emotion/styled";
import type { BaseTokenIconProps } from "@stepfinance/react";
import { white } from "@stepfinance/react";
import type { FC } from "react";

import { IconTextContainer, TokenIconText } from "../shared";
import { TokenIcon } from "../TokenIcon";

const TokenSymbol = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${white};
`;

export type TokenInfoDisplayProps = Pick<BaseTokenIconProps, "mintAddress"> & {
  symbol: string;
};

export const TokenInfoDisplay: FC<TokenInfoDisplayProps> = ({ mintAddress, symbol }) => (
  <IconTextContainer>
    <TokenIcon mintAddress={mintAddress} />
    <TokenIconText>
      <TokenSymbol className="token-text">{symbol}</TokenSymbol>
    </TokenIconText>
  </IconTextContainer>
);
